import React from 'react';
import {
  ChefHat,
  Minus,
  Plus,
  Trash2,
} from 'lucide-react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export default function PedidoMesaPanel({
  items,
  total,
  unidades,
  enviando,
  onCantidad,
  onObservaciones,
  onQuitar,
  onEnviar,
}) {
  if (!items.length) {
    return (
      <div className="mt-5 rounded-2xl border-2 border-dashed border-slate-200 px-6 py-10 text-center">
        <ChefHat
          size={32}
          className="mx-auto text-slate-300"
        />

        <p className="mt-3 font-bold text-azul-oscuro">
          Todavía no hay productos
        </p>

        <p className="mt-1 text-sm text-slate-500">
          Buscá o escaneá un producto para comenzar la comanda.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-5">
      <div className="space-y-3">
        {items.map((item) => (
          <article
            key={item.id}
            className="rounded-2xl border border-slate-200 bg-white p-4"
          >
            <div className="flex gap-4">
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-bold text-azul-oscuro">
                  {item.nombre}
                </h3>

                <p className="mt-1 text-sm font-semibold text-verde-oscuro">
                  {money(item.precio)}
                </p>
              </div>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => onCantidad(item.id, -1)}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-azul-oscuro transition hover:bg-slate-50"
                  aria-label={`Restar ${item.nombre}`}
                >
                  <Minus size={17} />
                </button>

                <strong className="w-7 text-center text-lg text-azul-oscuro">
                  {item.cantidad}
                </strong>

                <button
                  type="button"
                  onClick={() => onCantidad(item.id, 1)}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-verde-esmeralda text-white transition hover:opacity-90"
                  aria-label={`Sumar ${item.nombre}`}
                >
                  <Plus size={17} />
                </button>

                <button
                  type="button"
                  onClick={() => onQuitar(item.id)}
                  className="ml-1 flex h-9 w-9 items-center justify-center rounded-lg text-red-500 transition hover:bg-red-50"
                  aria-label={`Quitar ${item.nombre}`}
                >
                  <Trash2 size={17} />
                </button>
              </div>
            </div>

            <input
              type="text"
              value={item.observaciones || ''}
              onChange={(event) =>
                onObservaciones(
                  item.id,
                  event.target.value
                )
              }
              maxLength={500}
              placeholder="Observación: sin cebolla, bien cocido..."
              className="mt-3 h-10 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm text-slate-700 outline-none transition focus:border-verde-esmeralda focus:bg-white focus:ring-2 focus:ring-verde-esmeralda/20"
            />

            <div className="mt-2 text-right text-sm font-bold text-slate-600">
              {money(
                Number(item.precio) *
                  Number(item.cantidad)
              )}
            </div>
          </article>
        ))}
      </div>

      <div className="mt-5 rounded-2xl bg-slate-50 p-4">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {unidades}{' '}
              {unidades === 1
                ? 'producto'
                : 'productos'}
            </p>

            <strong className="mt-1 block text-2xl text-azul-oscuro">
              {money(total)}
            </strong>
          </div>

          <button
            type="button"
            disabled={enviando || !items.length}
            onClick={onEnviar}
            className="inline-flex min-h-12 items-center gap-2 rounded-xl bg-azul-oscuro px-5 py-3 font-bold text-white shadow-sm transition hover:bg-verde-esmeralda disabled:cursor-not-allowed disabled:opacity-50"
          >
            <ChefHat size={19} />

            {enviando
              ? 'Enviando...'
              : 'Enviar a cocina'}
          </button>
        </div>

        <p className="mt-3 text-right text-xs text-slate-400">
          Atajo: Ctrl + Enter
        </p>
      </div>
    </div>
  );
}
